<template>
    <v-dialog
      v-model="dialogImage"
      persistent
      max-width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn 
          v-if="btnabsolute"
          color="secondary"
          small
          absolute
          bottom
          left
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-square-edit-outline</v-icon>
        </v-btn>
        <v-btn 
          v-else
          color="secondary"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-square-edit-outline</v-icon>
        </v-btn>
      </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('global.editimage') }} <span v-if="video">/ Video</span></span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-form ref="imageForm">
                <v-file-input
                  v-if="video"
                  v-model="inputfile"
                  color="secondary"
                  accept="image/png, image/jpeg, image/jpg, video/mp4"
                  :error-messages="fileErrors"
                  show-size
                ></v-file-input>
                <v-file-input
                  v-else
                  v-model="inputfile"
                  color="secondary"
                  accept="image/png, image/jpeg, image/jpg"
                  :error-messages="fileErrors"
                  show-size
                ></v-file-input>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="dialogImage = false"
        >
          {{ $t('global.close')}}
        </v-btn>
        <v-btn
          color="error"
          class="ml-sm-2"
          @click="deleteFile"
        >
          {{ $t('global.delete')}}
        </v-btn>
        <v-btn
          class="ml-sm-2"
          color="primary"
          @click="uploadItem"
        >
          {{ $t('global.update')}}
        </v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import FileMixin from '../mixins/FileMixin';
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { maxsizefile } from '../utils/files';

export default {
  data: () => ({
    dialogImage: false,
    inputfile: null,
  }),
  props: {
    item: {
      type: Object,
      required: true
    },
    btnabsolute: {
      type: Boolean,
      default: true
    },
    video: {
      type: Boolean,
      default: false
    },
  },
  mixins: [FileMixin,validationMixin],
  computed: {
    fileErrors() {
      const errors = [];
      if (!this.$v.inputfile.$dirty) return errors;
      has(this.violations, 'file') && errors.push(this.violations.inputfile);
      !this.$v.inputfile.maxsizefile && errors.push(this.$t('global.maxsize'));
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  method: {
    sizeFile() {
      if(this.video) {
        return maxsizefile(50);
      } else {
        return maxsizefile(5);
      }
    }
  },
  validations() {
    if (this.video) {
      return {
        inputfile: {
          maxsizefile : maxsizefile(50),
        },
      }
    } else {
      return {
        inputfile: {
          maxsizefile : maxsizefile(5),
        },
      }
    }
  }
};
</script>
